import { HeartBank } from "../../../../managers/HeartBank.ts";
import { Humanity } from "../../../../managers/Humanity.ts";
//import { doc, getDoc } from "firebase/firestore";
//import { fs } from "../../../firebase.ts";

import template from "./hb-account.mjs";
import { render } from "lit-html";
import { HbMain } from "../../../hb-main/hb-main.ts";

//TODO: move x and fb to trove

export class HbAccount extends HTMLElement {
    private heartbank: HeartBank = new HeartBank();
    private humanity: Humanity = new Humanity();
    private main = document.querySelector("hb-main") as HbMain;

    private account: HTMLFormElement;
    private displayName: HTMLInputElement;
    private displayNameBtn: HTMLButtonElement;
    private email: HTMLInputElement;
    private emailBtn: HTMLButtonElement;

    constructor() {
        super();
        render(template(), this);

        this.account = this.querySelector("#hb-account")!;
        this.displayName = this.querySelector("#hb-account-displayName")!;
        this.displayNameBtn = this.querySelector(
            "#hb-account-displayName-btn"
        )!;
        this.email = this.querySelector("#hb-account-email")!;
        this.emailBtn = this.querySelector("#hb-account-email-btn")!;
    }

    connectedCallback() {
        this.account.addEventListener("submit", this.updateEmail.bind(this));
        this.displayNameBtn.addEventListener(
            "click",
            this.updateDisplayName.bind(this)
        );
        this.emailBtn.addEventListener("click", () => {
            localStorage.removeItem("emailForUpdate");
            render(template(this.heartbank.user), this);
        });

        this.heartbank.addAuthStateListener((user) => {
            // if (user) {
            //     const userDocRef = doc(fs, "users", user.uid);
            //     const userDocSnap = await getDoc(userDocRef);
            //     render(template(user, userDocSnap.data()), this);
            // } else render(template(user), this);
            render(template(user), this);
            //this.main.showSpinner();

            const fragments = window.location.hash.split("/");
            if (fragments[1] === "account") {
                if (user) {
                    if (fragments[2] === "updateSuccess") {
                        localStorage.removeItem("emailForLogin");
                        localStorage.removeItem("emailForUpdate");
                        render(template(user), this);
                        this.dispatch(
                            "Your email has successfully updated.",
                            "green"
                        );
                    } else {
                        //render(template(user), this);
                    }
                } else {
                    if (fragments[2] === "updateSuccess") {
                        // cross device
                        //const url = new URL(window.location.href);
                        window.location.hash = "#/login/again";
                        //window.location.href = url.toString();
                    } else window.location.hash = "#";
                }
            }

            //this.main.hideSpinner();
        });
    }

    rerender() {
        render(template(this.heartbank.user), this);
    }

    show() {
        this.account.classList.remove("hidden");
    }

    hide() {
        this.account.classList.add("hidden");
    }

    private dispatch(message: string, color: string) {
        const event = new CustomEvent<{ message: string; color: string }>(
            "hb-humanity",
            {
                detail: { message, color },
                bubbles: true, // allows the event to bubble up the DOM
                composed: true // allows it to pass through shadow DOM
            }
        );
        this.dispatchEvent(event);
    }

    private async updateEmail(event: Event) {
        event.preventDefault();
        this.main.showSpinner();
        const email = this.email.value.trim();

        if (email) {
            let status;
            status = await this.heartbank.updateEmail(email);

            if (status.color === "red") {
                status = await this.heartbank.handleSendEmailLink(
                    this.heartbank.user!.email!,
                    email
                );
            }

            this.email.placeholder = email;
            //this.main.renderSilver(this.heartbank.user);
            this.dispatch(status.text, status.color);
        }

        this.main.hideSpinner();
    }

    private async updateDisplayName(event: Event) {
        event.preventDefault();
        this.main.showSpinner();
        const displayName = this.displayName.value.trim();

        if (displayName) {
            try {
                const status = await this.humanity.updateDisplayName(
                    displayName
                );
                this.displayName.placeholder = displayName;
                this.main.renderSilver(this.heartbank.user);
                this.dispatch(status, "green");
            } catch (error: any) {
                this.dispatch(error.message, "red");
            }
        }

        this.main.hideSpinner();
    }
}
